'use strict';

/**
 * Checking if the slide is first or last
 *
 * @param {string} slick - carousel
 * @param {string} currentSlide - carousel slide
 * @return {undefined}
 */
function toggleArrowState(slick, currentSlide) {
    if (currentSlide === 0) {
        $('.slick-prev').addClass('disabled');
    } else {
        $('.slick-prev').removeClass('disabled');
    }

    if (currentSlide === slick.slideCount - 1) {
        $('.slick-next').addClass('disabled');
    } else {
        $('.slick-next').removeClass('disabled');
    }
}

/**
 * Initialize or Update the Slick Carousel
 */
function initializeOrUpdateSlick() {
    var $carousel = $('.slick-carousel');
    let carouselLength = $carousel.length;
    if (carouselLength && carouselLength > 0) {
        $carousel.each(function () {
            let configEle = $(this).closest('.custom-slick-carousel');
            if (configEle === null || configEle === undefined) {
                return true;
            }

            // Skip Slick initialization on mobile if no-column-gap is active
            var isMobile = $(window).width() < 768;
            var hasNoColumnGap = configEle.closest('.multi-column-layout-container').hasClass('no-column-gap');
            if (isMobile && hasNoColumnGap) {
                return true; // Skip Slick initialization
            }

            var noFluidityVideoItems = $(this).find('.slick-item[hasfluidityvideos="false"]');
            if (noFluidityVideoItems.length > 0) {
                noFluidityVideoItems.remove();
            }

            const xsPartial = configEle.data('xspartialslide');
            const smPartial = configEle.data('smpartialslide');
            const mdPartial = configEle.data('mdpartialslide');

            let partialSlide = {
                xs: xsPartial ? 0.2 : 0,
                sm: smPartial ? 0.2 : 0,
                md: mdPartial ? 0.2 : 0
            };

            const numberOfSlides = $(this).find('.slick-item').length;
            const slidesToShow = parseInt(configEle.data('md'), 10) < numberOfSlides ? parseInt(configEle.data('md'), 10) : numberOfSlides;
            const slidesToShowSm = parseInt(configEle.data('sm'), 10) < numberOfSlides ? parseInt(configEle.data('sm'), 10) : numberOfSlides;
            const slidesToShowXs = parseInt(configEle.data('xs'), 10) < numberOfSlides ? parseInt(configEle.data('xs'), 10) : numberOfSlides;

            let config = {
                slidesToShow: slidesToShow + partialSlide.md,
                dots: configEle.data('showdots-md'),
                arrows: configEle.data('showarrows-md'),
                speed: 300,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 999,
                        settings: {
                            slidesToShow: slidesToShowSm + partialSlide.sm,
                            dots: configEle.data('showdots-sm'),
                            arrows: configEle.data('showarrows-sm')
                        }
                    },
                    {
                        breakpoint: 699,
                        settings: {
                            slidesToShow: slidesToShowXs + partialSlide.xs,
                            dots: configEle.data('showdots-xs'),
                            arrows: configEle.data('showarrows-xs')
                        }
                    }
                ]
            };

            $(this).slick(config);

            $(this).on('afterChange', function () {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('setPosition');
                }
            });

            $(window).on('resize', function () {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('setPosition');
                }
            });

            $(this).on('init', function (event, slick) {
                toggleArrowState(slick, slick.currentSlide);
            });

            if ($(this).hasClass('slick-initialized')) {
                if ($(window).width() > 1000 && configEle.data('isdesktopcarousel') === false) {
                    $(this).slick('unslick');
                }
            }
            return true;
        });
    }
}

$(document).ready(function () {
    initializeOrUpdateSlick();
});
